var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.preload)?_c('div',{staticClass:"fd-preload d-flex justify-content-center align-items-center"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snippet",attrs:{"data-title":".dot-flashing"}},[_c('div',{staticClass:"stage"},[_c('div',{staticClass:"dot-flashing"})])])
}]

export { render, staticRenderFns }